<template>
  <div class="cardapio-digital-footer">
    <div class="container">
      <div class="is-flex is-justify-content-center is-align-content-center">
          <a class="" href="http://www.spicesoftware.com.br/" target="_blank">
            <img v-bind:src="caminho" alt="Footer">
          </a>
      </div>
    </div>

  </div>

</template>

<script>

export default {
  name: 'FooterFixo',
  data: () => ({
    caminho: "./img/Footer.png"
  })
}
</script>

<style>
.cardapio-digital-footer {
    position: fixed;
    padding-top: 6px;
    width: 100%;
    bottom: 0px;
    background-color: #f1f1f1;
    z-index: 1;
}

.cardapio-digital-footer img{
  /* filter: grayscale(10); */
  max-width: 161px;
  width: auto;
  height: auto;
}
</style>